import { BookDummy } from 'assets';
import Image from 'next/image';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { montserrat } from '@/components/Layout';
import { ISourceDocuments } from '@/components/ZAIChatLayout/ChatMessages';

interface Props {
  sourceDocument: ISourceDocuments;
  className?: string;
}

const BookCard: FC<Props> = ({ sourceDocument, className }) => {
  const getMetadataByPrefix = (
    metadata: Record<string, any> | undefined,
    prefix: string,
  ): string | null => {
    if (!metadata) return null;

    const key = Object.keys(metadata).find((k) => k.startsWith(prefix));
    return key ? metadata[key] : null;
  };
  const author = getMetadataByPrefix(sourceDocument?.metadata, 'author_');
  return (
    <div
      style={{
        fontFamily: montserrat.style.fontFamily,
      }}
      onClick={() => {
        if (typeof window !== 'undefined') {
          window.open(
            `/books/${sourceDocument.metadata.slug}-${sourceDocument.metadata.book_id}?utm_source=zai`,
            '_blank',
            'noopener,noreferrer',
          );
        }
      }}
      className={twMerge(
        'mx-[18px] hover:bg-grayZl-900/50 bg-grayZl-900 p-3 rounded-lg cursor-pointer transition-all',
        className,
      )}
    >
      <div className='flex items-center gap-3 mb-2'>
        <Image
          className='w-[50px] h-[68px] bg-contain rounded-sm'
          src={sourceDocument?.metadata?.book_image || BookDummy}
          width={50}
          height={68}
          alt='book'
        />
        <div className='flex flex-col gap-1.5'>
          <p className='font-light uppercase text-grayZl-500 text-[10px]'>
            BY {author}
          </p>
          <p className='text-xs font-bold text-grayZl-500'>
            {sourceDocument?.metadata?.book_name}
          </p>
        </div>
      </div>
      <p
        title={sourceDocument?.metadata?.short_description}
        className='text-xs text-grayZl-500 mb-[7px] line-clamp-2'
      >
        {sourceDocument?.metadata?.short_description}
      </p>
      <div>
        <div className='w-full h-px bg-grayZl-850 mb-2' />
        <p className='text-xs font-medium text-grayZl-500'>
          Page: {sourceDocument?.metadata?.page}
        </p>
      </div>
    </div>
  );
};

export default BookCard;
